import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import TypeGallery from "./pages/TypeGallery";
import CameraHub from "./pages/CameraHub";
import Cameras from "./pages/Cameras";
import Search from "./pages/Search";
import ParameterPage from "./pages/ParameterPage";
import RecipePageRoute from "./pages/RecipePageRoute";
import ViewGate from "./pages/ViewGate";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import LightMeter from "./pages/LightMeter";
import Builder from "./pages/Builder";
import Pricing from "./pages/Pricing";
import Unlock from "./pages/Unlock";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* Must come after /gallery so the exact path still matches its
            own route rather than falling through as a :type param. */}
        <Route path="/gallery/:type" element={<TypeGallery />} />
        {/* The index must be declared before the :cameraId route or
            "/cameras" would match as a camera whose id is empty. */}
        <Route path="/cameras" element={<Cameras />} />
        <Route path="/cameras/:cameraId" element={<CameraHub />} />
        {/* Single-topic technical reference: one camera, one parameter,
            answered across every axis that changes it. Must come after the
            hub route above so /cameras/:cameraId still matches on its own. */}
        <Route path="/cameras/:cameraId/:parameterId" element={<ParameterPage />} />
        <Route path="/camera/:slug" element={<RecipePageRoute />} />
        <Route path="/view/:slug" element={<ViewGate />} />
        <Route path="/builder" element={<Builder />} />
        <Route path="/search" element={<Search />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/light-meter" element={<LightMeter />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/unlock" element={<Unlock />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
